module.exports = __webpack_public_path__ + "b5306bf6297636eaae19ea2df221d6c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/colourScale/H@2x.png
// module id = 823
// module chunks = 0